import {useTranslation} from "next-i18next"
import React from "react"
import Typography from "../reusable/Typography/Typography"
import Button from "../reusable/components/Button"

type Props = {
    isCreditCheckPage?: boolean
}

const KonzeptBanner: React.FC<Props> = ({isCreditCheckPage}) => {
	const {t} = useTranslation()
	return (
		<>
			{
				isCreditCheckPage ?
					<section className="container mt-md-5 mb-4 mb-md-5 concept-wrapper"
						style={{borderRadius: 16, backgroundColor: "#F8F8F8"}}>
						<div className="row justify-content-between flex-column flex-column-reverse flex-md-row align-items-center">
							<div className="col-12 col-lg-5 text-md-start">
								<Typography variant="heading2Black"
									semanticTag="h2">
									{t("this-is-us-title")}
								</Typography>
								<Typography variant="bodyLg"
									semanticTag="p"
									className="mt-3 mb-4">
									{t("this-is-us-subtitle")}
								</Typography>
								<Typography variant="bodyLg"
									semanticTag="p"
									className="pb-4">
									{t("this-is-us-desc")}
								</Typography>
								<Button
									className={"shadow-none"}
									target="_blank"
									href={t("/konzept")}
									fontSizeSmall
									bgColor="#FEC04D"
									textColor="#212529"
									color="#212529">
									<Typography semanticTag="span"
										variant={"heading3SmBlack"}>{t("mehr erfahren")}</Typography>
								</Button>
							</div>
							<div className="col-5 rounded-3 d-none d-md-block">
								<iframe width="100%"
									style={{borderRadius: 4}}
									height="291"
									src="https://www.youtube.com/embed/OMUTAPWFMYs"
									title="YouTube video player"
									frameBorder="0"
									allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
									allowFullScreen></iframe>
							</div>
							<div className="col-12 mb-3 rounded-3 d-md-none">
								<iframe width="100%"
									style={{borderRadius: 4}}
									height="185"
									src="https://www.youtube.com/embed/OMUTAPWFMYs"
									title="YouTube video player"
									frameBorder="0"
									allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
									allowFullScreen></iframe>
							</div>
						</div>
					</section> :
					<section className="container mt-5 mb-4 mb-md-5 pb-0 pb-md-4">
						<div className="row justify-content-between align-items-center">
							<div className="col-12 col-lg-4 text-center text-md-start">
								<Typography variant="heading1"
									semanticTag="h1">
									{t("Was ist MyBikePlan?")}
								</Typography>
								<Typography variant="bodyLg"
									semanticTag="p"
									className="text-secondary">
									{t("MyBikePlan ist der einfachste Weg, ein E-Bike zu besitzen.")}
								</Typography>
							</div>
							<div className="col-12 col-lg-1"></div>
							<div className="col-12 col-lg-7">
								<iframe width="100%"
									height="420"
									src="https://www.youtube.com/embed/OMUTAPWFMYs"
									title="YouTube video player"
									frameBorder="0"
									allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
									allowFullScreen></iframe>
							</div>
						</div>
					</section>
			}
		</>
	)
}

export default KonzeptBanner

